import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import BASEURL from '../API/Config';

const StocksReport = () => {
  const [stocks, setStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem('token');

  // Fetch stocks when the component is mounted
  useEffect(() => {
    const fetchStocks = async () => {
      try {
        const response = await fetch(`${BASEURL}/stocks/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch stock data.');

        const data = await response.json();
        setStocks(data);
        setFilteredStocks(data);

        if (data.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'No Stock Data',
            text: 'There are no stock items available at the moment.',
          });
        }
      } catch (error) {
        console.error(error);
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: 'Failed to load stock data.',
        // });
      }
    };

    fetchStocks();
  }, [token]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter stocks based on search query
    const filtered = stocks.filter((stock) =>
      stock.itemName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredStocks(filtered);

    if (filtered.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Results Found',
        text: 'No stocks match your search query.',
      });
    }
  };

  // Export filtered stocks to Excel
  const handleExportExcel = () => {
    const data = filteredStocks.map((stock) => ({
      'Item ID': stock.id,
      'Item Name': stock.itemName,
      Category: stock.category,
      'Stock Quantity': stock.quantity,
      'Price per Unit': stock.pricePerUnit.toFixed(2),
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stocks Report');

    // Export the data to an Excel file
    XLSX.writeFile(wb, 'Stocks_Report.xlsx');
  };

  return (
    <div>
      <h4 className="text-center">Stocks Report</h4>

      {/* Search Bar */}
      <input
        type="text"
        className="form-control mb-4"
        placeholder="Search by item name"
        value={searchQuery}
        onChange={handleSearch}
      />

      {/* Export Excel Button */}
      <div className="d-flex justify-content-end mb-4">
        <button className="btn btn-success" onClick={handleExportExcel}>
          Export to Excel
        </button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Item ID</th>
            <th>Item Name</th>
            <th>Category</th>
            <th>Stock Quantity</th>
            <th>Price per Unit</th>
          </tr>
        </thead>
        <tbody>
          {filteredStocks.length > 0 ? (
            filteredStocks.map((stock) => (
              <tr key={stock.id}>
                <td>{stock.id}</td>
                <td>{stock.itemName}</td>
                <td>{stock.category}</td>
                <td>{stock.quantity}</td>
                <td>{stock.pricePerUnit.toFixed(2)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No stock data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StocksReport;
